import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import AuthenticatedLayout from './components/layout/AuthenticatedLayout';
import ProjectView from './components/project/ProjectView';
import { useAuth } from './hooks/useAuth';
import { AuthProvider } from './hooks/useAuth';

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <Box minH="100vh" bg="gray.50">
      <Routes>
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/projects" /> : <Login />} 
        />
        <Route 
          path="/signup" 
          element={isAuthenticated ? <Navigate to="/projects" /> : <Signup />} 
        />
        <Route 
          path="/projects" 
          element={isAuthenticated ? <AuthenticatedLayout /> : <Navigate to="/login" />} 
        />
        <Route 
          path="/project/:id" 
          element={isAuthenticated ? <ProjectView /> : <Navigate to="/login" />} 
        />
        <Route 
          path="/project/new" 
          element={<Navigate to="/projects" />} 
        />
        <Route 
          path="/" 
          element={<Navigate to={isAuthenticated ? "/projects" : "/login"} />} 
        />
      </Routes>
    </Box>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App; 